import(/* webpackMode: "eager" */ "/workspace/manjappada-landing-web/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/manjappada-landing-web/node_modules/react-bootstrap/esm/Carousel.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/manjappada-landing-web/node_modules/react-bootstrap/esm/CarouselCaption.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/manjappada-landing-web/node_modules/react-bootstrap/esm/CarouselItem.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/manjappada-landing-web/node_modules/react-bootstrap/esm/Col.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/manjappada-landing-web/node_modules/react-bootstrap/esm/Container.js");
;
import(/* webpackMode: "eager" */ "/workspace/manjappada-landing-web/node_modules/react-bootstrap/esm/Row.js");
;
import(/* webpackMode: "eager" */ "/workspace/manjappada-landing-web/src/app/home/body/FullBody.css");
;
import(/* webpackMode: "eager" */ "/workspace/manjappada-landing-web/src/app/gallery/styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/manjappada-landing-web/src/app/home/components/footer/index.jsx");
;
import(/* webpackMode: "eager" */ "/workspace/manjappada-landing-web/src/app/home/components/HeroSection/HeroSection.module.css");
;
import(/* webpackMode: "eager" */ "/workspace/manjappada-landing-web/src/components/shared/EmptyState/EmptyState.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/manjappada-landing-web/src/components/shared/imageGallery/imageModal.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/manjappada-landing-web/src/components/shared/navbar/index.jsx");
